// extracted by mini-css-extract-plugin
export default {"dialog":"ScheduleDialog_dialog__e2PMB"};